import { defineWidgetCore } from "../../widgetDefinition";
import { resolveTemplate } from "../../Utils/resolveTemplate";
import type { BodyMapComponentSpec, BodyMapNonSeriesResponse, ProcessedBodyMapDates } from "../../Processing/types";
import { renderBodyMap } from "../../PDF/renderers/bodyMapPdfRenderer";

export const bodyMapCore = defineWidgetCore<BodyMapComponentSpec>({
  process(spec, response) {
    const s = spec;
    const raw = response?.non_series_response as BodyMapNonSeriesResponse | undefined;

    const dates: ProcessedBodyMapDates = {};
    if (raw?.dates) {
      for (const [date, parts] of Object.entries(raw.dates)) {
        dates[date] = {};
        for (const [part, pt] of Object.entries(parts)) {
          dates[date][part] = pt.value;
        }
      }
    }

    return {
      type: "body_map",
      spec: s,
      bodyMap: { question_key: s.question_key, dates },
    };
  },
  pdf: {
    capture: "dom",
    // The body map is plain DOM SVG (not Highcharts), so its image is captured
    // via html2canvas in useExportPdf and injected into the chartImages map
    // keyed by widget id — same map this renderer reads from.
    buildSnapshot({ processed, slicerValues }) {
      if (processed.type !== "body_map") return null;
      const hasData = Object.keys(processed.bodyMap.dates).length > 0;
      if (!hasData) return null;
      const rawTitle = processed.spec.display.title;
      return {
        type: "body_map",
        title: rawTitle == null ? null : resolveTemplate(rawTitle, slicerValues).resolved,
        summary: null,
      };
    },
    render({ id, snapshot, rect, scale, chartImages }) {
      if (snapshot.type !== "body_map") return null;
      return renderBodyMap(snapshot, rect, scale, chartImages[id]);
    },
  },
});
